export const InputForm = (props) => {
    const {
        id,
        name,
        value,
        set,
        type,
        placeholder,
        required,
        onKeyUp,
        className,
        classNameWrapper,
        min,
        readOnly,
        max,
        onChange,
        autoComplete,
    } = props;

    return (
        <div className={classNameWrapper || ""}>
            {name && (
                <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">
                    {!required ? (
                        name
                    ) : (
                        <>
                            {name} <span className="text-red-600"> *</span>
                        </>
                    )}
                </label>
            )}
            {type === "textarea" && (
                <textarea
                    id={id ? id : name}
                    className={
                        className ||
                        "appearance-none block w-full bg-gray-200 text-app-primary border rounded-sm py-2 px-3 mb-3 leading-tight focus:outline-hidden focus:bg-white"
                    }
                    onKeyUp={onKeyUp}
                    name={name}
                    onChange={onChange ? onChange : (e) => {
                        set(e.target.value);
                    }}
                    placeholder={placeholder}
                    value={value}
                    readOnly={readOnly || false}
                    rows="5"
                    cols="33"
                />
            )}
            {type === "daymonth" && (
                <div className="flex gap-2 mb-3">
                    <select
                        value={new Date(value).getDate()}
                        onChange={onChange ? onChange : (e) => {
                            const day = parseInt(e.target.value);
                            const current = new Date(value);
                            current.setDate(day);
                            set(new Date(current));
                        }}
                        className="bg-gray-200 px-3 py-2 rounded-sm w-full h-10"
                    >
                        <option value="">Jour</option>
                        {Array.from({ length: 31 }, (_, i) => i + 1).map(
                            (d) => (
                                <option key={d} value={d}>
                                    {d}
                                </option>
                            )
                        )}
                    </select>
                    <select
                        value={new Date(value).getMonth() + 1}
                        onChange={onChange ? onChange : (e) => {
                            const month = parseInt(e.target.value) - 1;
                            const current = new Date(value);
                            current.setMonth(month);
                            set(new Date(current));
                        }}
                        className="bg-gray-200 px-3 py-2 rounded-sm w-full h-10"
                    >
                        <option value="">Mois</option>
                        {[
                            "Janvier",
                            "Février",
                            "Mars",
                            "Avril",
                            "Mai",
                            "Juin",
                            "Juillet",
                            "Août",
                            "Septembre",
                            "Octobre",
                            "Novembre",
                            "Décembre",
                        ].map((m, idx) => (
                            <option key={idx + 1} value={idx + 1}>
                                {m}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {!["textarea", "daymonth"].includes(type) && (
                <input
                    id={id ? id : name}
                    className={
                        className ||
                        "appearance-none block w-full bg-gray-200 text-gray-700 border rounded-sm py-2 px-3 mb-3 leading-tight focus:outline-hidden focus:bg-white h-10"
                    }
                    onKeyUp={onKeyUp}
                    name={name}
                    readOnly={readOnly || false}
                    value={value}
                    onChange={onChange ? onChange : (e) => {
                        if (type === "checkbox") {
                            set(!value);
                        } else {
                            if (type === "date") {
                                const dateValue = new Date(e.target.value);
                                const minDate = min ? new Date(min) : null;
                                const maxDate = max ? new Date(max) : null;

                                if (minDate && dateValue < minDate) {
                                    e.target.value = min;
                                }

                                if (maxDate && dateValue > maxDate) {
                                    e.target.value = max;
                                }
                            }

                            if (type === "number") {
                                let inputValue = e.target.value;

                                // Autoriser les virgules (converties en points)
                                inputValue = inputValue.replace(",", ".");

                                // Gérer la conversion en float
                                const floatValue = parseFloat(inputValue);

                                if (!isNaN(floatValue)) {
                                    if (
                                        typeof min === "number" &&
                                        floatValue < min
                                    ) {
                                        inputValue = min;
                                    }
                                    if (
                                        typeof max === "number" &&
                                        floatValue > max
                                    ) {
                                        inputValue = max;
                                    }
                                    set(floatValue);
                                } else {
                                    // Champ vide ou invalide → on vide la valeur
                                    set("");
                                }
                            }
                            if (
                                type === "text" &&
                                typeof max === "number" &&
                                e.target.value.length > max
                            ) {
                                e.target.value = e.target.value.substring(
                                    0,
                                    max
                                );
                            }
                            set(e.target.value);
                        }
                    }}
                    type={type || "text"}
                    placeholder={placeholder || ""}
                    required={required || false}
                    min={type === "date" || type === "number" ? min : undefined}
                    max={type === "date" || type === "number" ? max : undefined}
                    autoComplete={autoComplete || "off"}
                />
            )}
        </div>
    );
};
